import { get } from "./../https/http.service";

export const getHomeDetail = () => {
  return get("home/relatives");
};
